import React, { FC, ReactNode } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { useHistoryNew } from '@utils'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import './index.scss'

// interface
interface IProps extends RouteComponentProps {
  /** 文案提示 */
  msg?: ReactNode;
  desc?: ReactNode;
  /** 高度 */
  height?: string;
  /** icon类型 */
  iconType?: string;
  /** icon名称 */
  iconName?: string;
  /** 图片链接 */
  picUrl?: string;
  /** 跳转路由 */
  goHref?: string;
  /** 返回路由 */
  backHref?: string;
  /** 按钮文字 */
  btnText?: string;
  /** 按钮样式 */
  btnBg?: boolean;
  /** 按钮事件 */
  btnAction?: () => void;
}

const Empty: FC<IProps> = ({ msg, desc, height, iconType = 'iconfont', iconName, picUrl, goHref, backHref, btnText, btnBg, btnAction }) => {
  const history = useHistoryNew()

  // 跳转
  const handleGo = function () {
    history.push(goHref)
  }

  // 返回
  const handleBack = () => {
    history.replace(backHref)
  }

  return (
    <div
      className='empty'
      style={{ height, 'minHeight': height }}
    >
      {!picUrl ? <Icon icon={iconType} name={iconName} /> : <img className='pic' src={picUrl} />}
      <div className='text'>{msg}</div>
      {!!desc && <div className='desc'>{desc}</div>}
      {btnAction && (<div className={`btn-back${btnBg ? ' btn-back-bg' : ''}`} data-cypid='btnBack1' onClick={btnAction}>{btnText}</div>)}
      {backHref && (<div className='btn-back' data-cypid='btnBack2' onClick={handleBack}>{i18n.t('common.back')}</div>)}
      {goHref && (<div className='btn-go' data-cypid='btnBack3' onClick={handleGo}>{btnText || i18n.t('common.back')}</div>)}
    </div>
  )
}

export default withRouter(observer(Empty))
